var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1413_4578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1031 8.23958L13.7869 1.42188M6.1031 8.23958L8.54795 12.5781C8.5786 12.6375 8.62781 12.6877 8.68972 12.723C8.75163 12.7583 8.82365 12.777 8.89722 12.777C8.97078 12.777 9.0428 12.7583 9.10472 12.723C9.16663 12.6877 9.21584 12.6375 9.24648 12.5781L13.7869 1.42188M6.1031 8.23958L1.2134 6.07031C1.14652 6.04312 1.08984 5.99946 1.05011 5.94453C1.01038 5.88959 0.989258 5.82569 0.989258 5.76042C0.989258 5.69514 1.01038 5.63124 1.05011 5.57631C1.08984 5.52137 1.14652 5.47771 1.2134 5.45052L13.7869 1.42188",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1413_4578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillSend);
export default __webpack_public_path__ + "static/media/bill_send.f83b210fbc5bfba55ea8bcfa532712d6.svg";
export { ForwardRef as ReactComponent };